import React from 'react';
import uuid from 'uuid/v1';
import { FormattedMessage } from 'react-intl';

import ApplicationItem from './ApplicationItem';
import Checkbox from './Checkbox';
import { Value } from './ValueField';

const serviceFields = ['name', 'price', 'unit', 'value', 'amount'];

const SERVICES = [
    {
        name: 'shellScheme',
        minValue: 6,
        price: 470,
        unit: 'sqrm',
        primary: true,
    },
    {
        name: 'spaceOnly',
        minValue: 18,
        price: 420,
        unit: 'sqrm',
        services: ['upperDeck'],
        primary: true,
    },
    {
        name: 'upperDeck',
        minValue: 1,
        maxValue: true,
        price: 210,
        unit: 'sqrm',
        recalculate: true,
    },
    // {
    //     name: 'staticDisplayChalet3',
    //     minValue: 1,
    //     price: 5000,
    //     unit: 'unit',
    //     services: ['wallBrandingChalet3'],
    //     primary: true,
    // },
    // {
    //     name: 'wallBrandingChalet3',
    //     minValue: 1,
    //     price: 500,
    //     unit: 'unit',
    // },
    {
        name: 'staticDisplayChalet6',
        minValue: 1,
        price: 10000,
        unit: 'unit',
        services: ['wallBrandingChalet5'],
        primary: true,
    },
    {
        name: 'wallBrandingChalet5',
        minValue: 1,
        price: 1000,
        unit: 'unit',
    },
    {
        name: 'staticDisplay',
        primary: true,
        price: 270,
        unit: 'sqrm',
        values: {
            wingspan: {
                name: 'wingspan',
                unit: 'm',
                minValue: 1,
            },
            length: {
                name: 'length',
                unit: 'm',
                minValue: 1,
            },
        },
    },
    {
        name: 'brokerProject',
        minValue: 1,
        price: 2750,
        unit: 'unit',
        primary: true,
    },
    {
        name: 'firstTimeExhibitor',
        minValue: 1,
        price: 1250,
        unit: 'unit',
        primary: true,
    },
    // {
    //     name: 'catalogueAdPage05',
    //     price: 1630,
    //     catalogueAd: true,
    //     unit: 'unit',
    // },
    // { name: 'catalogueAdPage1', price: 3260, catalogueAd: true, unit: 'unit' },
];

function normolize(obj) {
    return serviceFields.reduce((o, key) => ({ ...o, [key]: obj[key] }), {});
}

export default class Application extends React.Component {
    state = {
        services: [{ id: uuid(), amount: 0 }],
        catalogueAd: SERVICES.filter((service) => service.catalogueAd).map(
            (item) => ({ ...item, value: 0, amount: 0 })
        ),
        total: 0,
    };

    render() {
        const { services, catalogueAd, total } = this.state;
        return (
            <div>
                <h6 className="title is-6">
                    <FormattedMessage id="exhibitApplication.allocationTitle" />
                </h6>
                {services.map((item) => (
                    <div key={item.id}>
                        <ApplicationItem
                            item={item}
                            services={SERVICES}
                            onChange={this.onChange}
                            showRemoveButton={this.showRemoveButton()}
                            onRemove={this.onRemove}
                        />
                        <hr />
                    </div>
                ))}
                {this.showAddButton() && (
                    <div>
                        <div className="is-flex">
                            <button
                                className="button is-primary"
                                onClick={this.addItem}
                                style={{ marginLeft: 'auto' }}
                            >
                                <FormattedMessage id="exhibitApplication.addButton" />
                            </button>
                        </div>
                        <hr />
                    </div>
                )}
                {/*<h6 style={{ marginBottom: '0.5rem' }}>
                    <FormattedMessage id="exhibitApplication.catalogueAd" />
                </h6>
                {catalogueAd.map((item) => (
                    <div
                        key={item.name}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Checkbox
                            selected={!!item.value}
                            onChange={() =>
                                this.handleCatalogueAdSelectChange(item)
                            }
                            messageId={`exhibitApplication.services.${
                                item.name
                            }.title`}
                        />
                        <p style={{ marginLeft: 'auto' }}>
                            <Value className="input is-static">
                                €{item.price}
                            </Value>
                        </p>
                    </div>
                ))}
                        <hr />*/}
                <h3 style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <FormattedMessage id="exhibitApplication.total" />:{' '}
                    <span style={{ paddingLeft: '1rem' }}>
                        €
                        {total}
                    </span>
                </h3>
            </div>
        );
    }

    onChange = (item, props) => {
        this.setState(
            {
                services: this.state.services.map(
                    (i) => (i.id === item.id ? { ...item, ...props } : i)
                ),
            },
            this.updateTotal
        );
    };

    onRemove = (item) => {
        this.setState(
            {
                services: this.state.services.filter((i) => item.id !== i.id),
            },
            this.updateTotal
        );
    };

    showRemoveButton = () => {
        return this.state.services.length > 1;
    };

    updateTotal = () => {
        const { services, catalogueAd } = this.state;
        const total =
            services.reduce(
                (sum, item) =>
                    sum +
                    item.amount +
                    (item.childServices
                        ? item.childServices.reduce(
                              (sum, i) => sum + i.amount,
                              0
                          )
                        : 0),
                0
            ) +
            catalogueAd.reduce(
                (sum, item) => (!!item.value ? sum + item.amount : sum),
                0
            );
        this.setState({
            total,
        });
        const normolizedServices = [
            ...services.filter((item) => !!item.name).reduce((arr, item) => {
                const { childServices, ...obj } = item;
                return [...arr, obj, ...childServices];
            }, []),
            ...catalogueAd.filter((item) => !!item.value),
        ].map((item) => normolize(item));
        this.props.onChange({
            total,
            services: normolizedServices,
        });
    };

    showAddButton = () => {
        return !this.state.services.filter((item) => !item.name).length;
    };

    addItem = () => {
        this.setState({
            services: [...this.state.services, { total: 0, id: uuid() }],
        });
    };

    handleCatalogueAdSelectChange = (item) => {
        const { catalogueAd } = this.state;
        const newValue = item.value ? 0 : 1;
        this.setState(
            {
                catalogueAd: catalogueAd.map(
                    (i) =>
                        i.name === item.name
                            ? {
                                  ...i,
                                  value: newValue,
                                  amount: item.price * newValue,
                              }
                            : i
                ),
            },
            this.updateTotal
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/components/Application.js